import React, { PureComponent } from 'react';
import style from './styles/style.module.css';

export default class TableCell extends PureComponent {
    render() {
        const { children } = this.props;
        const className = `dl-table-cell ${ style.tableCell } ${ this.props.className }`;
        return (
            <div className={ className }>
                { children }
            </div>
        );
    }
}
TableCell.defaultProps = {
    className: '',
};
